/* eslint-disable react/no-array-index-key */
import { useEffect } from 'react';
import { HeadingDescSmall } from '../../Headings';
import arrowIconPink from '../../../assets/images/svg/arrow-right-pink-border.svg';
import arrowIconBlue from '../../../assets/images/svg/arrow-right-blue-border.svg';
import './docLocationCard.css';

function DocLocationCard(props) {
  const { locations } = props;

  useEffect(() => {
    // const checkBtnText = btnText.toUpperCase();
    const selectCard = document.getElementsByClassName('docLocationCard');
    // eslint-disable-next-line prettier/prettier
    const selectRoundIconBlue = document.getElementsByClassName('roundArrowIconBlue');
    // eslint-disable-next-line prettier/prettier
    const selectRoundIconPink = document.getElementsByClassName('roundArrowIconPink');
    const cardbtnText = document.getElementsByClassName(
      'underline_ancer_small'
    );
    for (let i = 0; i < selectCard.length; i += 1) {
      if (cardbtnText[i].innerHTML === 'IN-PERSON APPOINTMENT') {
        selectCard[i].classList.add('pinkcard');
        selectRoundIconPink[i].classList.remove('d-none');
      } else {
        selectRoundIconBlue[i].classList.remove('d-none');
        selectCard[i].classList.add('tiffannyblue');
      }
    }
  });

  return (
    <div className="locationContainer">
      {locations.map((singleLocation, index) => {
        const { price, location, available, btnText, onClick } = singleLocation;
        return (
          <div className="docLocationCard" key={index}>
            <div className="price">
              <HeadingDescSmall text={price} />
            </div>
            <div className="content">
              <div className="location">
                <HeadingDescSmall text={location} />
              </div>
              <div className="available">
                <HeadingDescSmall text={available} />
              </div>
              <div className="btnContainer">
                <img
                  src={arrowIconPink}
                  alt="roundArrowIcon"
                  className="roundArrowIconPink d-none"
                />
                <img
                  src={arrowIconBlue}
                  alt="roundArrowIcon"
                  className="roundArrowIconBlue d-none"
                />
                <button
                  type="button"
                  onClick={onClick}
                  className="underline_ancer_small "
                >
                  {btnText}
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
export default DocLocationCard;
